import { render } from "./ColorwayEditor.vue?vue&type=template&id=c60291c8&scoped=true"
import script from "./ColorwayEditor.vue?vue&type=script&lang=js"
export * from "./ColorwayEditor.vue?vue&type=script&lang=js"

import "./ColorwayEditor.vue?vue&type=style&index=0&id=c60291c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60291c8"]])

export default __exports__